<template>
  <div class="regDialogView">
    <el-dialog
      :visible.sync="regVisible"
      :close-on-click-modal="false"
      width="818px"
      :show-close="true"
      class="regDialog"
      id="loginDialog"
      :before-close="close1"
    >
      <div class="container row-center-start">
        <div
          class="left-conetnt content-item c-white
        px-30 py-50"
        >
          <p class="f-26 fw-700 pb-10">快哦</p>
          <p class="pb-30 f-18">电商企业智能工具平台</p>
          <p class="list-yu">3秒极速注册</p>
          <p class="list-yu">
            注册后免费检测<span style="font-style:oblique" class="f-18 fw-bold c-lightyellow px-5">50</span>张图片
          </p>
          <p class="list-yu">
            注册后<span class="f-18 fw-bold c-lightyellow px-5"><i style="font-style:oblique">永久免费</i></span
            >检测文字
          </p>
          <p class="list-yu">
            覆盖<span style="font-style:oblique" class="f-18 fw-bold c-lightyellow px-5">20+</span>行业，<span
              style="font-style:oblique"
              class="f-18 fw-bold c-lightyellow px-5"
              >10000+</span
            >个违禁词
          </p>
          <p class="list-yu">检测结果云端保存，实时可查</p>
          <p class="list-yu">一号可绑定多店，支持多人协同</p>
        </div>
        <div class="irght-content content-item">
          <div class="center">
            <div class="title" style="margin-bottom:20px">{{ title }}</div>

            <p v-show="wxBinding && shopToolToken" class="font12">
              首次使用需要绑定手机，<span style="color:#FF3E40" class="font12">绑定后可直接扫码登录</span>
            </p>
            <p>
              <el-input
                placeholder="请输入手机号码"
                class="phoneInput"
                clearable
                v-model="phone"
                :maxlength="11"
                @keyup.enter.native="regEvent"
                style="color: #000;"
              >
                <i slot="prefix" class="ml5" style="color:#000;">+86</i>
              </el-input>
            </p>
            <p class="dfc">
              <el-input v-model="codeText" placeholder="请输入验证信息" class="mr5" @keyup.enter.native="regEvent"></el-input>
              <img v-if="verificationCode.image" :src="'data:image/png;base64,' + verificationCode.image" alt="" style="margin-right: 4px;">
              <el-button
                type="text"
                @click="fetchVerificationCode"
                >换一张</el-button
              >
            </p>
            <p class="dfc">
              <el-input
                placeholder="请输入验证码"
                class="mr5"
                :maxlength="4"
                v-model="code"
                clearable
                @keyup.enter.native="regEvent"
              >
              </el-input>
              <el-button
                plain
                :class="show ? 'getCodeBtn' : 'setCodeBtn'"
                @click="getCode"
                :style="show ? '' : 'width:158px'"
                :disabled="!show"
                >{{ show ? "获取验证码" : count + "s后可重发" }}</el-button
              >
            </p>
            <p>
              <el-input
                placeholder="请输入6-20位密码"
                type="password"
                :show-password="true"
                v-model="password"
                :maxlength="20"
                @keyup.enter.native="regEvent"
              >
              </el-input>
            </p>
            <div class="submitView mb20 mt30">
              <el-button type="primary" class="regBtn" @click="regEvent">{{ btnName }}</el-button>
            </div>
            <div class="tips dfcjsb mt20">
              <p>登录即同意<span class="userPact curp" @click="toUserPact">《用户协议》</span></p>
              <p v-show="!wxBinding && !shopToolToken">
                已有账号？<a href="javascript:;" class="blueFont" @click="toLogin">去登录</a>
              </p>
            </div>
          </div>
          <!-- <div class="newReg mt-0 " v-show="!wxBinding && !shopToolToken">
            <div class="tc dfcjc pt10">
              <img src="../assets/regIcon.png" alt="" class="mr10" />
              <span class="fontw">新用户权益</span>
            </div>
            <div class="item">
              <p class="font12">
                <i class="el-icon-check mr5"></i>
                <span>注册后可获得无限次文字检测</span>
              </p>
              <p class="font12">
                <i class="el-icon-check mr5"></i>
                <span>注册后可获得50张图片检测</span>
              </p>
              <p class="font12">
                <i class="el-icon-check mr5"></i>
                <span>注册后可获得10个1688产品检测</span>
              </p>
              <p class="font12">
                <i class="el-icon-check mr5"></i>
                <span>注册后检测结果可查</span>
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: [],
  components: {},
  data() {
    return {
      title: "注册账号",
      btnName: "注册账号",
      phone: "",
      code: "",
      timer: "",
      show: true,
      count: "",
      password: "",
      clickMark: false, //连点拦截
      verificationCode: {},
      codeText: "",
    };
  },
  computed: {
    ...mapState(["regVisible", "shopToolToken", "loginMode", "wxBinding", "Sign"]),
  },
  updated() {
    if (this.wxBinding && this.shopToolToken) {
      this.title = "绑定手机号";
      this.btnName = "绑定手机号";
    } else if (this.shopToolToken) {
      this.title = "注册快哦";
      this.btnName = "注册快哦";
    } else {
      this.title = "注册账号";
      this.btnName = "注册账号";
    }
  },
  watch: {
    regVisible(val) {
      if (val) {
        this.fetchVerificationCode();
      }
    },
  },
  mounted() {
    if (this.shopToolToken) {
      this.title = "注册快哦";
      this.btnName = "注册快哦";
    }
  },
  created() {},
  methods: {
    fetchVerificationCode() {
      this.$ajax.get('/kuaio/api/Member/Login/GetVerificationCode').then(res => {
          this.verificationCode = res.result;
      })
    },
    toLogin(userInfo) {
      let self = this;
      this.$store.state.loginMode = 3;
      this.$store.commit("setRegVisible", false);
      this.$store.commit("setUserInfoCache", userInfo);
      setTimeout(() => {
        this.$store.commit("setLoginVisible", true);
      }, 300);
    },
    close1(done) {
      this.$store.commit("setRegVisible", false);
      let self = this;
      if (this.title == "注册快哦") {
        self.$utils.buryingpoint("快哦绑定账号--关闭");
        self
          .$confirm("<p>确定要放弃注册？</p><span class='redFont'>放弃将失去所赠送的50张图片违禁词</span>", "", {
            dangerouslyUseHTMLString: true,
            type: "warning",
            cancelButtonText: "继续注册",
            confirmButtonText: "放弃",
            cancelButtonClass: "cancelButtonClass",
            confirmButtonClass: "confirmButtonClass",
          })
          .then(() => {
            self.$utils.buryingpoint("快哦绑定账号--关闭--放弃注册");

            self.$store.commit("delShopToolToken");
            self.$store.commit("setRegVisible", false);
            self.$store.commit("setWxBinding", false);
            self.$store.commit("delSign");
          })
          .catch(() => {
            self.$utils.buryingpoint("快哦绑定账号--关闭--继续注册");
          });
        return;
      }

      this.$store.commit("delShopToolToken");
      this.$store.commit("setRegVisible", false);
      this.$store.commit("setWxBinding", false);
      this.$store.commit("delSign");
    },
    //获取验证码
    getCode() {
      if (!this.phone) return this.$message.error("请输入正确的手机号");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return this.$message.error("请输入正确的手机号码");
      if (!this.codeText || this.codeText.length != 4) return this.$message.error("请输入正确的验证信息");
      this.phone = Number(this.phone);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        let ajaxData = {
          mobilePhone: this.phone,
          verificationCodeType: this.wxBinding ? 2 : 0,
          verificationData: this.$md5('kuaio' + this.codeText + this.verificationCode.code)
        };
        this.$ajax
          .post("/kuaio/api/Member/Member/SentVerificationCode", ajaxData)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
            if (res.code != 200) this.$message.error(res.msg);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    getHash(name) {
      var loca = window.location;
      var baseUrl = loca.origin + loca.pathname;
      var query = window.location.hash;
      if (query.indexOf(name) > -1) {
        var obj = {};
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=");
          obj[arr[i][0]] = arr[i][1];
        }
        delete obj[name];
        let hash = JSON.stringify(obj)
          .replace(/[\"\{\}]/g, "")
          .replace(/\:/g, "=")
          .replace(/\,/g, "&");
        hash = hash.replace("#/", "");
        return hash;
      }
    },
    //注册账号
    regEvent() {
      let self = this;
      if (self.clickMark) return;
      self.clickMark = true;
      setTimeout(() => {
        self.clickMark = false;
      }, 3000);
      if (!self.phone) return self.$message.error("请输入正确的手机号");
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) return self.$message.error("请输入正确的手机号码");
      if (!self.codeText || self.codeText.length != 4) return self.$message.error("请输入正确的验证信息");
      if (!self.code || self.code.length != 4) return self.$message.error("请输入正确的验证码");
      if (!self.password) return self.$message.error("请输入正确的密码");
      let length = self.password.length;
      if (length < 6 || length > 20) return self.$message.error("请输入6-20位密码");
      let ajaxData = {
        mobilePhone: Number(self.phone),
        password: this.$md5(self.password),
        verificationCode: self.code,
      };
      if (self.shopToolToken) ajaxData.shopToolToken = self.shopToolToken;

      if (!self.wxBinding) {
        self.$ajax
          .post("/kuaio/api/Member/Member/Register", ajaxData)
          .then((res) => {
            if (res.code == 200 && !self.shopToolToken) {
              self.$message.success({ message: res.msg, duration: 1200 });
              let userInfo = {
                mobilePhone: Number(self.phone),
                password: self.password,
              };
              let pointData = {
                functionTypeName: "快哦注册",
                userId: res.result.kuaiOId,
                account: Number(self.phone),
                callback: (resp) => {},
              };
              self.$utils.buryingpoint(pointData);
              self.toLogin(userInfo);
            }
            if (res.code == 200 && self.shopToolToken) {
              let result = res.result;
              let expirationTime = self.$utils.formatTime(result.expirationTime, "yyyy-MM-dd hh:mm:ss");
              let userInfo = {
                userPhone: self.phone,
                expirationTime,
                token: result.token,
                kuaiOId: result.kuaiOId,
                floatingShowFlag: true,
              };
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              self.$store.commit("checkUserStatus");
              self.$utils.buryingpoint("快哦绑定账号");
              self.$message.success({
                message: "绑定成功",
                duration: 1000,
                onClose: (res) => {
                  self.title = "注册账号";
                  self.close();
                  self.$store.commit("delShopToolToken");
                },
              });
            }
            if (res.code != 200) self.$message.error(res.msg);
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.$ajax
          .post("/kuaio/api/Member/Member/BindWx", {
            Sign: self.Sign,
            MobilePhone: Number(self.phone),
            password: self.$md5(this.password),
            Code: self.code,
          })
          .then(function(res) {
            if (res.code == 200) {
              let result = res.result;
              let expirationTime = self.$utils.formatTime(result.expirationTime, "yyyy-MM-dd hh:mm:ss");
              let userInfo = {
                userPhone: self.phone,
                expirationTime,
                token: result.token,
                kuaiOId: result.kuaiOId,
                floatingShowFlag: true,
              };
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              self.$store.commit("checkUserStatus");
              self.$utils.buryingpoint("快哦扫码后绑定");

              self.$message({
                message: "绑定成功",
                type: "success",
              });

              if (!self.$checkLogin(true)) return;
              // GetAliPackageCount 获取
              self.$store.dispatch("GetFwPackageQuantity");
              self.$store.commit("delShopToolToken");
              self.$store.commit("delSign");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else if (res.code == 4011) {
              self.$message({
                message:
                  "<div class='mr40'> <p>绑定手机超时,请重新扫码绑定</p> <p class='mt10'>扫码后请在30分内完成绑定</p> </div>",
                type: "warning",
                duration: 3000,
                dangerouslyUseHTMLString: true,
              });
              setTimeout(function() {
                self.$store.commit("setRegVisible", false);
                self.$store.commit("setLoginVisible", true);
              }, 3000);
            } else {
              self.$message.error(res.msg);
            }
          })
          .catch(function(err) {
            self.$message.error("绑定失败");
          });
      }
    },
    //跳转到 用户协议
    toUserPact() {
      this.$emit("showUserPack");
    },
    //注册成功 埋点
    resBeburyPoint() {
      this.$utils.buryingpoint("快哦注册");
    },
  },
};
</script>

<style lang="scss" scoped>
.line-height {
  line-height: 1;
}

.container {
  width: 100%;
  height: 450px;
  border-radius: 8px;
  background-color: #fff;

  .content-item {
    height: 100%;
    & > .list-yu {
      padding: 4px 0 4px 25px;
      line-height: 1.6;
      position: relative;
      &::before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 16px;
        height: 16px;
        // background-color: #fff;
        content: "";
        background-image: url("../assets/icon_gouxua.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
    }
  }
  .left-conetnt {
    width: 348px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url("../assets/left-content.png");
  }
  .irght-content {
    width: calc(100% - 348px);
    // position: relative;
  }
}
#loginDialog {
  & > .el-dialog {
    & > .el-dialog__header {
      padding: 0;
    }
  }
}
.regDialogView {
  .regDialog {
    background: transparent;
    .center {
      padding: 10px 80px;
      text-align: center;
      .title {
        font-size: 18px;
        color: #000;
        font-weight: 600;
        margin-top: 22px;
        margin-bottom: 40px;
      }
      p {
        margin-bottom: 15px;
      }
      .getCodeBtn {
        background: #eee;
        border: 1px solid #eee;
        color: #000;
        width: 112px;
      }
      .setCodeBtn {
        background: #eee;
        border: 1px solid #eee;
        color: #999;
      }
      .regBtn {
        width: 100%;
      }
      .tips {
        color: #aaa;
      }
      .userPact {
        color: #aaa;
      }
      .userPact:hover {
        //color: #1c64f4;
        color: #aaa;
      }
    }
    .newReg {
      // height: 100px;
      background: #fffae4;
      border-radius: 0 0 6px 6px;
      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 15px;
        padding-top: 10px;
        p {
          width: 50%;
          margin-bottom: 10px;
        }
        .el-icon-check {
          color: #000;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    a:hover {
      color: #1c64f4;
    }
  }
}
</style>
<style lang="scss">
.cancelButtonClass {
  background-color: #1c64f4 !important;
  border-color: #1c64f4 !important;
  color: #ffffff !important;
}
.confirmButtonClass {
  background: #ffffff !important;
  border: 1px solid #dddddd !important;
  border-color: #dddddd !important;
  color: #666666 !important;
}
.confirmButtonClass:hover span {
  color: #666666 !important;
}
.confirmButtonClass span {
  color: #666666 !important;
}
.regDialogView {
  .el-dialog__headerbtn {
    font-size: 20px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .phoneInput {
    .el-input__prefix {
      display: flex;
      align-items: center;
    }
    .el-input__inner {
      color: #000;
      padding-left: 42px;
    }
  }
}
.regDialogView {
  .el-dialog__header {
    padding: 0;
  }
  /deep/ .regDialog {
    .el-dialog {
      height: 450px;
    }
  }
}
</style>
